import { render, staticRenderFns } from "./RegionPricingTableView.vue?vue&type=template&id=28a76907&scoped=true"
import script from "./RegionPricingTableView.vue?vue&type=script&lang=js"
export * from "./RegionPricingTableView.vue?vue&type=script&lang=js"
import style0 from "./RegionPricingTableView.vue?vue&type=style&index=0&id=28a76907&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a76907",
  null
  
)

export default component.exports